/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Vs_Word4Inputs */

const en_wc_vs_word4 = /** @type {(inputs: Wc_Vs_Word4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charts, SmartArt and complex documents survive every round trip.`)
};

/**
* | output |
* | --- |
* | "Charts, SmartArt and complex documents survive every round trip." |
*
* @param {Wc_Vs_Word4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_vs_word4 = /** @type {((inputs?: Wc_Vs_Word4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Vs_Word4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_vs_word4(inputs)
});
export { wc_vs_word4 as "wc.vs.word4" }